<template>
    <div>
        <nsw-banner ref="nsw"></nsw-banner>
        <div
                class="basic-message-box"
                v-show="storeResource.total_resources === 0"
        >
            <p>{{ lang($t("Coming soon")) }}</p>
        </div>

        <template v-if="storeResource.content_type === 'single'">
            <div class="content-wrapper resources" v-show="storeResource.total_resources > 0" >
                <h3 class="title-head">{{ storeResource.table_heading }}</h3>

                <div class="obj-resources-table">
                    <!--thead-->
                    <SubCateListTableHeading
                            v-bind:table_key="-1"
                    ></SubCateListTableHeading>
                    <!--tbody-->
                    <ResourceListItem
                            v-bind:cate_list="storeResource.cate_list"
                    ></ResourceListItem>
                    <!---end tbody-->
                </div>


            </div>
        </template>
        <template v-else="content_type === 'group'">
            <div v-show="storeResource.total_resources > 0">
                <div class="content-wrapper resources"
                     v-for="(resources, table_key) in storeResource.cate_list"
                     v-show="getGroupResourceTotal(resources) > 0"
                >
                    <h3 class="title-head">{{ resources.heading }}</h3>

                    <div class="obj-resources-table">
                        <!--thead-->
                        <SubCateListTableHeading
                                v-bind:table_key="table_key"
                        ></SubCateListTableHeading>
                        <!--tbody-->
                        <ResourceListItem
                                v-bind:cate_list="resources.resource"
                        ></ResourceListItem>
                        <!---end tbody-->
                    </div>

                </div>
            </div>
        </template>

        <div style="text-align: right; padding: 1.5rem;">&copy; {{ getCopyRight() }}</div>
    </div>
</template>

<script>

    import Vue from 'vue';
    import axios from 'axios';
    import router from '@js/routes';
    import {common} from '@mixins/common';
    import {storeMapper} from '@mixins/storeMapper';
    import api from '@js/api';
    import EventBus from '@common/eventBus';
    import HkepCheckBox from '@/HkepCheckBox';
    import HkepLabel from '@/HkepLabel';
    import SubCateListTableHeading from '@/SubCateListTableHeading';
    import ResourceListItem from '@/ResourceListItem';

    export default {
        name: "ireaderResourcePage",
        mixins:[common, storeMapper],
        components: {
            HkepCheckBox,
            HkepLabel,
            SubCateListTableHeading,
            ResourceListItem
        },

        data: function() {
            return {
                content_type: "single",
                id:null, //the subcate id for getting the resource data
                cateTitle:null, //main cate title
                //cateBgColor:null, //main cate background color; used to display on breadcrumb (on desktop screen)
                subcateTitle:null, //sub cate title
                isShowFilter:false, //whether show the filter button or not)
                showMyDownload: true,
                showCheckBox: true
            }
        },
        /**
         * 當路由有更新, 例如 [YOUR_IP:PORT]/sub_cate_list?id=XXX 當中的 URL query param XXX 轉變時,beforeRouteUpdate 會 listen;
         * sub cate id 有更新後只要再 fetchData 便可; fetchData 裏會讀取 URL query param
         */
        beforeRouteUpdate (to, from, next) {
            next();
            this.fetchData();
        },
        /**路由相處理
         * 第一次進入本頁面時的動作。
         * @param to
         * @param from
         * @param next
         */
        beforeRouteEnter (to, from, next) {

            //Note in this route guard, access 'this' using vm (e.g. vm.fetchData() will trigger this.fetchData()
            next(vm=> {
                EventBus.$emit("showGlobalLoading");

                Promise.all(
                    [
                        api.getMainCate(),
                        api.getBanner(),
                    ]
                    //With catch(() => undefined, we'll continue to the immediate "then block" even one/some of the api call(s) is/are rejected
                    //If something has to be processed when error returns, place the logic in catch block instead
                        .map(p => p.catch(() => undefined)))
                    .then(axios.spread((responseMainCate, responseBanner) => {
                        if (responseMainCate) {
                            vm.setWebSiteAndCate( responseMainCate.data, vm);
                        }


                        if (responseBanner) {
                            vm.$store.commit('banner/setBanner', responseBanner.data);
                        }

                        vm.$refs.nsw.startCarousel();
                        vm.fetchData();
                        EventBus.$emit("hideGlobalLoading");
                        EventBus.$emit("hideHeaderRightPanel");


                    }));

            });
        },
        methods: {
            fetchData() {

                jQuery(".header-logo a").attr("href", "https://www.hkep.com" );

                this.id = this.$route.params.id;

                if (!this.id) {
                    router.push({ name: 'NotFound' });
                }
                EventBus.$emit("showGlobalLoading");

                api.getResourcePageFrontendById(this.id).then(resp=> {
                    this.$store.commit("resource_store/setCateData", {
                        cate_title: resp.data.col_title,
                        cate_list:  resp.data.resources,
                        table_heading:resp.data.table_heading,
                        total_resources:resp.data.count,
                        content_type:resp.data.content_type,
                        mobile_order:resp.data.mobile_order,
                        filter:resp.data.filter,
                        download_display_type: resp.data.download_display_type
                    });

                    if (this.storeResource.content_type === 'group') {
                        for(var key=0; key < this.storeResource.cate_list.length; key++ ) {
                            this.storeResource.check_all_group_resource[key] = false;
                        }
                    } else {
                        this.storeResource.check_all_resource = false;

                    }

                    if (this.checkIsShowFilter()) {
                        EventBus.$emit("setCriteria", resp.data.filter);
                    }

                    this.updateRelationUrl(this.id);

                    this.$store.commit("resource_store/clear_sub_cate");

                    EventBus.$emit('unselect_all_subcate');


                }).catch(function (resp) {
                    EventBus.$emit("hideGlobalLoading");
                    //catch 之後的 then(), 無論 axios 成功或是失敗, 總會執行
                }).then(()=> {

                    jQuery(".pull-right").hide();

                    this.resetMainAppSize();

                    Vue.nextTick(()=>{
                        if(window.MathJax) {
                            window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => {
                                EventBus.$emit("closeMobileMenu");
                                EventBus.$emit("hideGlobalLoading");
                            });
                        }
                    });

                });

            },
            getGroupResourceTotal(resources)
            {

                let dispalyable = resources.resource.filter(el=>{
                    return el.is_filtered === null || el.is_filtered === false;
                });

                return dispalyable.length
            },
            getCopyRight()
            {

                var current_year = new Date().getFullYear();
                return this.lang(this.$t("1999-%year% Hong Kong Educational Publishing Company Limited. All rights reserved."),
                    {
                        year: current_year,
                    });
            }
        }
    }
</script>

<style>
    .obj-resources-table:last-child {
        margin-bottom: 0;
    }

    /* make table heading hidden */
    @media (max-width: 500px) {
        .bg-secondary {
            display: none !important;
        }
    }
    input[type=checkbox]+label, input[type=radio]+label {
        display: none !important;
    }

    .mobile-header-btn.left-corner,
    .mobile-header-btn.right-corner {
        display: none;
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ireaderResourcePage/ireaderResourcePage.vue